// extracted by mini-css-extract-plugin
export var boxItems = "_9p-1";
export var boxItemsLg = "_9p-2";
export var button = "_9p-7";
export var buttonHoverless = "_9p-9";
export var buttonLg = "_9p-8";
export var filterGroupBox = "_9p-0";
export var icon = "_9p-3";
export var iconSecondary = "_9p-6";
export var iconWrapper = "_9p-4";
export var iconWrapperLg = "_9p-5";
export var truncatedLabel = "_9p-a";